<template>
  <v-hover v-slot="{ hover }">
    <v-card
      class="transparentBack"
      :elevation="hover ? 10 : 6"
      :to="!admin ? link : ''"
      style="max-width: min(460px, calc(100vw - 30px))"
    >
      <v-img
        class="fotoHolder"
        width="100%"
        height="140"
        :src="imgSrc"
        position="bottom center"
      />
      <v-sheet
        class="pa-4 backgroundGradient"
        :class="{ sameHeight: !admin }"
      >
        <v-text-field
          v-if="admin"
          v-model="title"
          :label="label"
          class="py-2"
        />
        <v-card-title
          v-else
          class="py-2"
        >
          {{ title }}
        </v-card-title>
        <tinyMCE
          v-if="admin"
          v-model="bottomText"
          :init="{
            content_css: false,
            skin: false,
            setup: function (ed) {
              ed.on('init', function () {
                this.getDoc().body.style.fontSize = '12';
                this.getDoc().body.style.fontFamily = 'Roboto, sans-serif';
              });
            },
            statusbar: false,
            height: 300,
            menubar: false,
            language_url: '/langs/de.js',
            language: 'de',
            block_formats: 'Text=p; Überschrift 1=h1; Überschrift 2=h2',
            plugins: ['lists', 'link', 'paste'],
            paste_as_text: true,
            default_link_target: '_blank',
            toolbar:
              'undo redo | bold italic underline | link | bullist numlist outdent indent | formatselect | removeformat',
          }"
        />
        <v-card-text
          v-else
          @click="e => e.stopPropagation()"
        >
          <span
            :class="{
              barrierefrei: $route.query.barrierefrei,
            }"
            v-html="bottomText"
          />
        </v-card-text>
      </v-sheet>
    </v-card>
  </v-hover>
</template>

<script>
import bindingsTextbausteine from '@/store/bindingsTextbausteine';
import tinyMCE from '@tinymce/tinymce-vue';

export default {
  components: {
    tinyMCE
  },
  props: {
    admin: {
      type: Boolean,
      default: () => false
    },
    label: {
      type: String,
      default: () => ''
    },
    link: {
      type: String,
      default: () => ''
    },
    imgSrc: {
      type: String,
      default: () => ''
    },
    titleModel: {
      type: String,
      default: () => ''
    },
    bottomTextModel: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...bindingsTextbausteine(),
    title: {
      get: function() {
        return this[this.titleModel];
      },
      set: function(newValue) {
        this[this.titleModel] = newValue;
      }
    },
    bottomText: {
      get: function() {
        return this[this.bottomTextModel];
      },
      set: function(newValue) {
        this[this.bottomTextModel] = newValue;
      }
    }
  }
};
</script>

<style scoped>
.barrierefrei {
  font-size: 16px !important;
}

.transparentBack {
  background: none;
}

.backgroundGradient {
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 60%,
    rgba(255, 255, 255, 0.4) 100%
  );
}

.sameHeight {
    height: 280px;
  }

</style>
